import { isGlobalProject } from 'config';
import {
  ClientType,
  OnboardingTaxResidency,
} from 'modules/onboarding/common/components';

import { useTaxResidency } from '../hooks';
import { PageComponentProps } from '../types';

export const TaxResidencyStep = ({ canGoBack }: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    files,
    submitDisabled,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    goToBack,
  } = useTaxResidency();

  return (
    <OnboardingTaxResidency
      canGoBack={canGoBack}
      clientType={ClientType.ClientRepresentative}
      countries={countries}
      countriesLoading={countriesLoading}
      enabledFiles={isGlobalProject()}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
